import { Card, Row, Col, FormGroup } from 'react-bootstrap'
import LessonsFilter from '../../../ui/Selects/SelectLessons/SelectLessons'
import { useEffect, useMemo, useState } from 'react'
import { ISelectData } from '../../../ui/Selects/select/model'
import {
  useCreateBadgeMutation,
  useGetBadgeByIdQuery,
  useUpdateBadgeMutation
} from '../../../store/api/badges/badges.api'
import { useNavigate, useParams } from 'react-router-dom'
import { responseError, validationRequaired } from '../../../validation/validationRequaired'
import { IBadgeDataToBack } from '../../../store/api/badges/model'
import { toast } from 'react-toastify'
import { IValidationRequired } from '../../../validation/model'
import { useTranslation } from 'react-i18next'
import { closeValidateRequiredError } from '../../../validation/validation'
import { createSingleSelectData } from '../../../utils/createSingleSelectData'
import IsArabicCheckBox from '../../../ui/IsArabicCheckBox/IsArabicCheckBox'

const CreateBadges = (): JSX.Element => {
  const { id } = useParams()
  const { t: tGeneral } = useTranslation('general')
  const { data: badgeSingleData } = useGetBadgeByIdQuery(id, {
    skip: !id
  })
  const [createBadge] = useCreateBadgeMutation()
  const [updateBadge] = useUpdateBadgeMutation()
  const navigate = useNavigate()
  const [lessonSelected, setLessonSelected] = useState<ISelectData>()
  const [errorRequired, setErrorRequired] = useState<IValidationRequired>({})
  const [badgeDataToBack, setBadgeDataToBack] = useState<IBadgeDataToBack>({
    name: '',
    lessonId: null,
    file: null,
    lang: 'en'
  } as IBadgeDataToBack)
  const isRtl = useMemo(
    () => (badgeDataToBack.lang === 'ar' ? 'rtl' : 'ltr'),
    [badgeDataToBack?.lang]
  )

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault()

    setErrorRequired(validationRequaired(badgeDataToBack))
    if (!Object.values(validationRequaired(badgeDataToBack)).length) {
      const res = id
        ? await updateBadge({ ...badgeDataToBack, id: Number(id) })
        : await createBadge(badgeDataToBack)
      if ('error' in res) {
        responseError(res)
      } else {
        toast.success(id ? 'Badge Was Updated' : 'Badge Was Created')
        navigate(-1)
      }
    }
  }

  const onChange = (name: string, value: string | File | number): void => {
    setBadgeDataToBack(prev => {
      const updatedData: IBadgeDataToBack = { ...prev, [name]: value }

      if (name === 'file' && value instanceof File) {
        updatedData.image = URL.createObjectURL(value)
      }

      return updatedData
    })
  }

  useEffect(() => {
    if (lessonSelected?.value) {
      onChange('lessonId', lessonSelected.value)
    }
  }, [lessonSelected])

  useEffect(() => {
    if (id && badgeSingleData) {
      setBadgeDataToBack({
        description: badgeSingleData.description,
        name: badgeSingleData.name,
        id: badgeSingleData.id,
        image: badgeSingleData.image,
        lang: badgeSingleData.lang
      } as IBadgeDataToBack)

      setLessonSelected(
        createSingleSelectData(badgeSingleData.lesson.name, badgeSingleData.lesson.id)
      )
    }
  }, [id, badgeSingleData])

  return (
    <div>
      <Card.Header>
        <div>
          <h2>{tGeneral(id ? 'editBadge' : 'createBadge')}</h2>
        </div>
      </Card.Header>
      <Row>
        <Col lg={12} xl={12} md={12} sm={12}>
          <Card>
            <IsArabicCheckBox
              lang={badgeDataToBack?.lang}
              changeLangFunc={lang => setBadgeDataToBack(prev => ({ ...prev, lang }))}
            />
            <form onSubmit={onSubmit}>
              <Card.Body>
                <Row>
                  <Col xs={6} md={12}>
                    <FormGroup>
                      <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                        {tGeneral('Name')}
                      </label>
                      <input
                        defaultValue={badgeDataToBack?.name}
                        name='name'
                        className='form-control'
                        placeholder={tGeneral('name')}
                        onChange={({ target }) => onChange(target.name, target.value)}
                        dir={isRtl}
                        onClick={() =>
                          closeValidateRequiredError('name', errorRequired, setErrorRequired)
                        }
                      />
                      {errorRequired?.name && (
                        <span className='text-danger'>{errorRequired?.name}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={12}>
                    <FormGroup>
                      <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                        {tGeneral('description')}
                      </label>
                      <textarea
                        defaultValue={badgeDataToBack?.description}
                        name='description'
                        className='form-control'
                        onChange={({ target }) => onChange(target.name, target.value)}
                        placeholder={tGeneral('description')}
                        dir={isRtl}
                        onClick={() =>
                          closeValidateRequiredError('description', errorRequired, setErrorRequired)
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={12}>
                    <FormGroup>
                      <label className='text-dark mt-5' htmlFor='exampleInputname'>
                        {tGeneral('file')}
                      </label>
                      <input
                        type='file'
                        className='form-control'
                        name='file'
                        dir={isRtl}
                        accept='image/*'
                        defaultValue={badgeDataToBack?.image}
                        onChange={({ target }) => onChange(target.name, target.files[0])}
                        alt=''
                      />
                      {errorRequired?.file && (
                        <span className='text-danger'>{errorRequired?.file}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <div>
                    {badgeDataToBack?.image && (
                      <div className='avatar avatar-lg  brround cover-image bg-primary mr-10'>
                        <img
                          style={{ width: '200px' }}
                          src={badgeDataToBack?.image}
                          className='avatar avatar-lg  brround cover-image bg-primary'
                          alt=''
                        />
                      </div>
                    )}
                  </div>
                  <Col
                    className={`w-100 d-flex ${
                      isRtl === 'rtl' ? 'justify-content-end' : 'justify-content-start'
                    }  `}
                    xs={12}
                    md={12}
                  >
                    <Col xs={12} md={6} className='p-0'>
                      <LessonsFilter
                        lessonSelected={lessonSelected}
                        setLessonSelected={setLessonSelected}
                        isRtl={isRtl}
                      />
                      {errorRequired?.lessonId && (
                        <span className='text-danger'>{errorRequired?.lessonId}</span>
                      )}
                    </Col>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer className='text-end'>
                <button className='btn btn-success mt-1 me-2'>{tGeneral('save')}</button>
                <button
                  type='button'
                  className='btn btn-danger mt-1 me-2'
                  onClick={() => navigate(-1)}
                >
                  {tGeneral('cancel')}
                </button>
              </Card.Footer>
            </form>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default CreateBadges
